import * as React from 'react';
import { buildTranslator, StaticTextCustomFormField } from '../../../../amorg-common';
import { H3 } from '../../../../designSystem/typography/Heading';

type StaticTextCustomFormFieldComponentProps = {
    field:StaticTextCustomFormField,
}
export function StaticTextCustomFormFieldComponent(props:StaticTextCustomFormFieldComponentProps):JSX.Element
{
    const translator = buildTranslator('da');

    return (
        <section>
            <H3>{translator(props.field.header)}</H3>
            <div dangerouslySetInnerHTML={{ __html: translator(props.field.text) }} />
        </section>
    );
}